import { useState, useEffect } from 'react';
import { Box, FormControl, Grid, TextField } from '@mui/material';
import SelectGroupProvider from '../../../../../dsasComponents/SelectGroupProvider.js';
import { getUserProvider, isAdminDSAS } from '../../../../../actions/auth.js';
import DateTimePicker_Dsas from '../../../../../dsasComponents/DateTimePicker_Dsas.js';
import SelectMultiUser from '../../../../../dsasComponents/SelectMultiUser.js';
import useStyles from '../../../../../styles/global-mui.js';
import DsasButton from '../../../../../v1/components/DsasButton/DsasButton.js';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { usePermissions } from '../../../../../permissions/usePermissions.js';
import { PERMISSIONS } from '../../../../../permissions/permissionKeys.js';
import { useSelector } from 'react-redux';

const Step1 = ({ state, setState, onSubmit, isEditMode}) => {
  const [provider, setProvider] = useState(state.provider);
  const [name, setName] = useState(state.name);
  const [dateTime, setDateTime] = useState(state.dateTime);
  const [userNames, setUserNames] = useState(state.userNames)

  const { getPermission } = usePermissions();
  const providerPermission = getPermission(PERMISSIONS.FILTER_PROVIDER);

  // const currentUser = useSelector(state => state.authentication.currentUser);
  // const providerqqq = currentUser?.groups; 
  // const testProvider = getUserProvider();
  // console.log('Provider from auth:', providerqqq);
  // console.log('Provider from getUserProvider:', testProvider);

  useEffect(() => {
  setProvider(state.provider);
  setName(state.name);
  setDateTime(state.dateTime);
  setUserNames(state.userNames);
}, [state]);

  useEffect(() => {
    if(isEditMode){
      setState(s => ({...s, provider, name, dateTime, userNames}))
    }

  }, [provider, name, dateTime, userNames])

  const handleNext = () => {
      onSubmit({ name, provider, dateTime, userNames });
  };

  const isNextDisabled = !name || !dateTime || !provider;

  const classes = useStyles();

  return (
     <>  
     <Grid container spacing={1.5}>
            <Grid item xs={12} sm={12} md={12}>
              {/* Live name */}
              <TextField
                className={classes.customInput}
                id="name"
                label="Nom du direct"
                variant="standard"
                margin="normal"
                fullWidth
                value={name}
                onChange={(e) => setName(e.target.value)}
                error={!name}
                helperText={!name ? 'Veuillez saisir un nom de direct.' : ''}
              />
            </Grid>
        </Grid>  

        <Box className='medium-padding'></Box>

        <Grid container spacing={1.5}>
            <Grid item xs={12} sm={3} md={3}>
               {/* Live date */}
              <DateTimePicker_Dsas
                  fullwidth
                  className={classes.customInput}
                  label={"Début du direct"}
                  name={"dateTime"}
                  value={dateTime}
                  onChange = {setDateTime}
              />
            </Grid>

            {providerPermission?.allowed && (<Grid item xs={12} sm={3} md={3}>
              {/* Group */}
                <FormControl fullWidth 
                  className={classes.customInput}
                  variant="standard" 
                  margin="normal"
                  sx={{marginTop:0}}
                  >
                  <SelectGroupProvider value={provider} onChange={(e) => setProvider(e.target.value)}/>
                </FormControl>            
            </Grid>)}

            <Grid item xs={12} sm md>
              {/* Users */}
                <SelectMultiUser className={classes.customInput} handleChangeUsers={(users) => setUserNames(users)} usersSelected={userNames} provider={provider}></SelectMultiUser>
            
            </Grid>
        </Grid>

        <Box className='medium-padding'></Box>
        <Box className='medium-padding'></Box>
        <Box className='large-separator'></Box>
        {/* <Box className='medium-padding'></Box> */}

         {!isEditMode && 
           <Box className='padding-wrapper display-grid'>
              <DsasButton 
                onClick={handleNext} 
                icon={faArrowRight}
                label="Etape suivante" 
                variant = 'alternative' 
                disabled={isNextDisabled} 
                customCss={{width: '170px',
                  justifySelf: 'right',
                  display: 'flex',
                  flexDirection: 'row-reverse',
                  flexWrap: 'nowrap',
                  alignContent: 'flex-start',
                  justifyContent: 'space-evenly',
                  alignItems: 'center'}}
              />
           </Box>
         
         
      //    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      //   <Box sx={{ flex: 1 }}>
      //     <Button variant="contained" onClick={handleNext} disabled={isNextDisabled}>Suivant</Button>
      //   </Box>
      // </Box>
      
      } 

    </>
  );
}

export default Step1;